import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { numberToOrdinalWord } from 'further-ui/utils';

type Props = {
  onChange: (commitmentId?: string) => void;
  commitmentIds: Array<string>;
  selectedCommitmentId?: string | null;
};

const MultipleCommitmentTabs: React.FC<Props> = ({
  onChange,
  commitmentIds,
  selectedCommitmentId,
}) => {
  return (
    <Tabs
      value={selectedCommitmentId ?? 0}
      onChange={(_, value) => {
        onChange(value);
      }}
      variant="scrollable"
      scrollButtons={false}
    >
      <Tab key={0} label="All commitments" value={0} />
      {commitmentIds.map((commitmentId, index) => (
        <Tab
          key={commitmentId}
          label={`${numberToOrdinalWord(index + 1)} commitment`}
          value={commitmentId}
        />
      ))}
    </Tabs>
  );
};

export default MultipleCommitmentTabs;
